import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoTitle from 'eco-design/base/eco-title';
import EcoButton from 'eco-design/base/eco-button';
import React, { useRef, useState, useEffect } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import { getMemberListProducts } from '@elem/compPage/delta-3-max-series/service';
import getLocal from 'eco-design-reliance/getLocal';
import FormatCurrencyLocal from 'eco-design-reliance/currency/FormatCurrencyLocal';
import { saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';

const SingleItemCard = ({ addShopCartCallback }: any) => {
    const { t } = useLang('Delta3MaxSeriesStation.SingleItemCard');
    const { locale = 'jp' } = getLocal();
    const [productList, setProductList] = useState([
        {
            variantId: '52157995123055',
            learnMore: 'https://jp.ecoflow.com/products/delta-3-max-plus-portable-power-station',
            btn1: t('btn1'),
            btn2: t('btn2'),
            desc: [t('desc1_1'), t('desc1_2'), t('desc1_3'), t('desc1_4')],
        },
        {
            variantId: '52156760129903',
            learnMore: 'https://jp.ecoflow.com/products/delta-3-max-portable-power-station',
            btn1: t('btn1'),
            btn2: t('btn2'),
            desc: [t('desc2_1'), t('desc2_2'), t('desc2_3'), t('desc2_4')],
        },
    ]);
    const getProductData = () => {
        try {
            getMemberListProducts(
                {
                    variantIds: ['52157995123055', '52156760129903'],
                },
                locale,
            ).then((res) => {
                if (res.code === '0' && res.data) {
                    const list = productList.map((item: any) => {
                        const findItem = res.data.find((v: any) => v.variantId === item.variantId) || {};
                        return {
                            ...item,
                            ...findItem,
                            buyUrl: `https://${locale}.ecoflow.com/cart/${findItem.variantId}:1?channel=buy_button`,
                        };
                    });
                    setProductList(list);
                }
            });
        } catch (error) {
            console.log('error->>', error);
        }
    };
    const handleAddCart = (info: any, listName: string, className2: string) => {
        addShopCartCallback(
            {
                ...info,
                discountPrice: info.price,
                originalPrice: info.compareAtPrice,
                variantId: info.variantId,
                inventory: info.inventoryQuantity,
                inventoryPolicy: info.inventoryPolicy,
                img: info.img,
                title: info.skuTitle,
                buyText: 'カートに入れる', //埋点好像需要用这个呀
                className2,
            },
            listName,
        );
    };
    useEffect(() => {
        getProductData();
    }, []);
    return (
        <section className={`${styles.SingleItemCard} GtmModuleData-section`} id="SingleItemCard" data-section-id={'SingleItemCard'}>
            <div className="main">
                <EcoTitle title={t('title')} />

                <div className="Product-card">
                    {productList.map((item, index) => {
                        return (
                            <div className="cart">
                                <div className="cart-l">
                                    <EcoImg pc={item.variantImg}></EcoImg>
                                </div>
                                <div className="cart-r">
                                    <p className="label">{t('new')}</p>
                                    <p className="title">{item.skuTitle && item.skuTitle !== 'Default Title' ? item.skuTitle : item.productTitle}</p>
                                    <ul>
                                        {item.desc.map((item) => {
                                            return <li>{item}</li>;
                                        })}
                                    </ul>
                                    <p className="price">
                                        <span className="price-1">{FormatCurrencyLocal(item?.price, locale)}</span>
                                        <span className="price-2">{FormatCurrencyLocal(item?.compareAtPrice, locale)}</span>
                                    </p>
                                    <div className="btns">
                                        <EcoButton
                                            className={`GtmModuleData-btn-href list-item-btn-${index + 1}`}
                                            lHref={item.learnMore}
                                            lTheme="black"
                                            lDataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'buy',
                                                product_name: item.btn1,
                                                position: item.learnMore,
                                                __btn_id1: `btns .list-item-btn-${index + 1}`,
                                                __btn_id2: saveCookieForShopify(item.learnMore, locale),
                                                __btn_type: 'href',
                                            }}
                                        >
                                            {item.btn1}
                                        </EcoButton>
                                        <EcoButton
                                            className={`GtmModuleData-btn-common list-item-${index + 1}`}
                                            data-btn-id={`list-item-${index + 1}`}
                                            onClick={() => {
                                                handleAddCart(
                                                    item,
                                                    item.skuTitle && item.skuTitle !== 'Default Title' ? item.skuTitle : item.productTitle,
                                                    `list-item-${index + 1}`,
                                                );
                                            }}
                                            lTheme="black"
                                            lType="outlined"
                                        >
                                            {item.btn2}
                                        </EcoButton>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default SingleItemCard;
